var Flickity = require('flickity');
require('flickity-imagesloaded');

var sliders = document.querySelectorAll('.image-slider');

for (i = 0; i < sliders.length; i += 1) {
  var slider = new Flickity(sliders[i], {
    dragThreshold: 10,
    cellAlign: 'left',
    contain: true,
    imagesLoaded: true,
    arrowShape: 'M62,76c-0.5,0-1-0.2-1.4-0.6l-24-24c-0.8-0.8-0.8-2,0-2.8l24-24c0.8-0.8,2-0.8,2.8,0c0.8,0.8,0.8,2,0,2.8L40.8,50l22.6,22.6 c0.8,0.8,0.8,2,0,2.8C63,75.8,62.5,76,62,76z'
  });


  function addFocusSelectHandlerToElem(elem, cellIdx) {
    elem.setAttribute('cellIdx', cellIdx);
    elem.onfocus = function(e) {
      var selectedIndex = e.currentTarget.getAttribute('cellIdx');

      if (selectedIndex) {
        if (selectedIndex === '1') {
          slider.select(2, false, true);
          window.setTimeout(function() { slider.select(1, false, true); }, 0);
        }
        else {
          slider.select(selectedIndex, false, true);
        }
      }
    }
  }

  function addFocusSelectHandlerToElems(elems, cellIdx) {
    for (elemIdx = 0; elemIdx < elems.length; elemIdx += 1) {
      addFocusSelectHandlerToElem(elems[elemIdx], cellIdx);
    }
  }

  // Go through each slider cell
  for (cellIdx = 0; cellIdx < slider.cells.length; cellIdx += 1) {
    addFocusSelectHandlerToElems(
      slider.cells[cellIdx].element.querySelectorAll('a'),
      cellIdx
      );

  }
}


// Autoplay video no supported in iOS devices so hide
var iOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
var android = /Android/.test(navigator.userAgent);


if(iOS || android) {

  if (document.querySelector('.image__item--video')!=null) {
    document.querySelector('.image__overlay').style.display = 'block';
    document.querySelector('.image__item__video').style.display = 'none'
  }
}

